import {ConfigSetting} from "../entities/ConfigSetting";
import {BaseService} from "./BaseService";
import { StateService } from "@uirouter/angularjs";

export class ConfigSettingService extends BaseService<ConfigSetting>{
    static CMDACTIVETIMEOUT:string = "CMDACTIVETIMEOUT";
    static CMDUSEMETERS:string = "CMDUSEMETERS";
    static CMDMAPREFRESH:string = "CMDMAPREFRESH";
    static $inject = ['$http','$q','$state','localStorageService'];
    constructor($http: ng.IHttpService, $q: ng.IQService, $state: StateService,public locStorage:angular.local.storage.ILocalStorageService) {
        super($http, $q, $state, ConfigSetting);
    }
    protected getBaseUrl():string{
        return "configsetting";
    }
    getByName(name:string):ng.IPromise< ConfigSetting > {
        var config:any = {};
        return this.useBaseGetHandler(this.getBaseUrl(),"?name="+name, config);
    }
    add(name:string,value:string):ng.IPromise<boolean>{
        return this.usePostHandler(this.getBaseUrl(),"?name="+name+"&value="+value, null).then((data)=>{
            return this.$q.when(true);
        });
    }
    getCmdActiveTimeout(ignoreLocal:boolean=false):ng.IPromise<number>{
        var activeTimout:number = this.locStorage.get<number>(ConfigSettingService.CMDACTIVETIMEOUT);
        if (activeTimout != null && !ignoreLocal) {
            return this.$q.when<number>(activeTimout);
        }
        return this.getByName(ConfigSettingService.CMDACTIVETIMEOUT).then((data)=>{
            var activeTimeout:number = parseInt(data.value);
            this.locStorage.set(ConfigSettingService.CMDACTIVETIMEOUT,activeTimeout);
            return this.$q.when<number>(activeTimeout);
        });
    }
    getCmdUseMeters(ignoreLocal:boolean=false):ng.IPromise<boolean>{
        var useMeters:boolean = this.locStorage.get<boolean>(ConfigSettingService.CMDUSEMETERS);
        if (useMeters != null && !ignoreLocal) {
            return this.$q.when<boolean>(useMeters);
        }
        return this.getByName(ConfigSettingService.CMDUSEMETERS).then((data)=>{
            var useMeters:boolean = data.value === "true" ? true : false;
            this.locStorage.set<boolean>(ConfigSettingService.CMDUSEMETERS,useMeters);
            return this.$q.when<boolean>(useMeters);
        });
    }
    getCmdMapRefresh(ignoreLocal:boolean=false):ng.IPromise<number>{
        var mapRefresh:number = this.locStorage.get<number>(ConfigSettingService.CMDMAPREFRESH);
        if (mapRefresh != null && !ignoreLocal) {
            return this.$q.when<number>(mapRefresh);
        }
        return this.getByName(ConfigSettingService.CMDMAPREFRESH).then((data)=>{
            var mapRefresh:number = parseInt(data.value);
            this.locStorage.set(ConfigSettingService.CMDMAPREFRESH,mapRefresh);
            return this.$q.when<number>(mapRefresh);
        });
    }
}
